import { render, staticRenderFns } from "./UpdateRoomTheme.vue?vue&type=template&id=55127f79&scoped=true&"
import script from "./UpdateRoomTheme.vue?vue&type=script&lang=js&"
export * from "./UpdateRoomTheme.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55127f79",
  null
  
)

export default component.exports